/* import __COLOCATED_TEMPLATE__ from './verify-email-domain.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { type PulseAccordion } from 'glint/pulse';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { isBlank } from '@ember/utils';

interface Signature {
  Args: {
    accordion: PulseAccordion;
    onContinue: () => void;
  };
}

export default class VerifyEmailDomainComponent extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: $TSFixMe;

  get app() {
    return this.appService.app;
  }

  get salesforceConfig() {
    return this.finStandaloneService.salesforceConfig;
  }

  get isDisabled() {
    return isBlank(this.salesforceConfig?.supportEmail);
  }

  get isComplete() {
    return this.salesforceConfig?.isSupportDomainVerified;
  }

  get selectedSupportDomainSettings() {
    return this.salesforceConfig?.selectedSupportDomainSettings;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Cases::ConfigureEmails::VerifyEmailDomain': typeof VerifyEmailDomainComponent;
    'standalone/deploy/salesforce/cases/configure-emails/verify-email-domain': typeof VerifyEmailDomainComponent;
  }
}
